import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  without: '5-8 hs/semana buscando tutoriales en YouTube en inglés',
  with: '10 minutos mirando el plano y arrancás a fabricar'
}, {
  without: 'Sin planos reales, el mueble no sale como querías',
  with: 'Planos con medidas exactas para los 9 proyectos'
}, {
  without: 'Gastás mal en materiales porque no sabés qué pedir',
  with: 'Lista de materiales con cantidades exactas y dónde conseguirlos en Argentina'
}, {
  without: 'Sin fórmula de precio, regalás tu trabajo o no vendés nada',
  with: 'Fórmula de precio probada con margen real de hasta 143%'
}, {
  without: 'No sabés cómo fotografiar ni dónde vender',
  with: 'Sistema de fotografía premium con celular y 5 canales de venta en Argentina'
}, {
  without: 'Meses fabricando sin un solo cliente',
  with: 'Roadmap mes a mes de 0 a $3000 USD con acciones concretas'
}, {
  without: 'Sin técnicas que justifiquen precios altos',
  with: 'Técnica Shou Sugi Ban y diseño propio que nadie puede replicar'
}, {
  without: 'Fabricar se queda en hobby y nunca genera plata',
  with: 'Negocio real con lista de espera de clientes'
}];
export function Comparison() {
  return <section className="py-8 md:py-16 px-4 bg-[#EDE6D8]" data-id="element-33">
      <div className="max-w-6xl mx-auto" data-id="element-34">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-5xl font-bold text-center mb-6 md:mb-12" data-id="element-35">
          LA REALIDAD
        </motion.h2>

        <p className="text-center text-base md:text-xl mb-6 md:mb-8 font-semibold" data-id="element-36">
          ¿Cuánto cuesta NO tenerlo?
        </p>

        <div className="bg-white rounded-lg overflow-hidden border border-[#2B2724]/10" data-id="element-37">
          <div className="grid grid-cols-2 md:grid-cols-2 divide-x divide-[#2B2724]/10" data-id="element-38">
            <div className="bg-red-50/30 p-2 md:p-4 text-center font-bold text-[10px] md:text-base" data-id="element-39">
              Sin el Megapack
            </div>
            <div className="bg-green-50/30 p-2 md:p-4 text-center font-bold text-[10px] md:text-base" data-id="element-40">
              Con el Megapack
            </div>
          </div>

          {comparisons.map((comparison, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="grid grid-cols-2 md:grid-cols-2 divide-x divide-[#2B2724]/10 border-t border-[#2B2724]/10" data-id="element-41">
              <div className="p-3 md:p-4 flex flex-col md:flex-row items-start gap-2 md:gap-3" data-id="element-42">
                <X className="w-4 h-4 md:w-5 md:h-5 text-red-500 flex-shrink-0 md:mt-0.5 mx-auto md:mx-0" data-id="element-43" />
                <p className="text-[10px] md:text-sm text-[#2B2724]/70 text-center md:text-left" data-id="element-44">
                  {comparison.without}
                </p>
              </div>
              <div className="p-3 md:p-4 flex flex-col md:flex-row items-start gap-2 md:gap-3 bg-[#F5F0E8]/50" data-id="element-45">
                <Check className="w-4 h-4 md:w-5 md:h-5 text-[#8B9A8E] flex-shrink-0 md:mt-0.5 mx-auto md:mx-0" data-id="element-46" />
                <p className="text-[10px] md:text-sm font-medium text-center md:text-left" data-id="element-47">
                  {comparison.with}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}